module.exports = __webpack_public_path__ + "img/title.1434e003.png";